module.exports = __webpack_public_path__ + "static/media/ckn_platillo_nuevo_adicionales.9e2a2ccf.jpg";